module.exports = __webpack_public_path__ + "img/ehi-latest.a47da43f.png";